"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateFullNameFieldValue = exports.getFullNameFieldEmptyValue = void 0;
const full_name_1 = require("../../../utils/full-name");
const getFullNameFieldEmptyValue = () => {
    return {
        title: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        sys_root: "",
    };
};
exports.getFullNameFieldEmptyValue = getFullNameFieldEmptyValue;
const generateFullNameFieldValue = (field, value) => {
    var _a, _b, _c, _d, _e;
    const sysRoot = (0, full_name_1.formatFullName)(field, value);
    return {
        title: (_a = value === null || value === void 0 ? void 0 : value.title) !== null && _a !== void 0 ? _a : "",
        first_name: (_b = value === null || value === void 0 ? void 0 : value.first_name) !== null && _b !== void 0 ? _b : "",
        middle_name: (_c = value === null || value === void 0 ? void 0 : value.middle_name) !== null && _c !== void 0 ? _c : "",
        last_name: (_d = value === null || value === void 0 ? void 0 : value.last_name) !== null && _d !== void 0 ? _d : "",
        sys_root: (_e = sysRoot !== null && sysRoot !== void 0 ? sysRoot : value === null || value === void 0 ? void 0 : value.sys_root) !== null && _e !== void 0 ? _e : "",
    };
};
exports.generateFullNameFieldValue = generateFullNameFieldValue;
